<div class="layout-row layout-align-start-center gap-5">
  <div *ngIf="!supportNullState" class="form-check">
    <input class="form-check-input shadow-none"
           [ngClass]="size"
           #checkbox
           type="checkbox"
           [checked]="isChecked"
           [disabled]="isDisabled"
           (click)="onClick($event)">
  </div>

  <div *ngIf="!!supportNullState" class="layout-row layout-align-start-center full-height">

    <div *ngIf="isChecked === null"
         class="null-state layout-column layout-align-center-center"
         (click)="onClick($event)">
      <div></div>
    </div>

    <input *ngIf="isChecked !== null"
           class="form-check-input shadow-none"
           [ngClass]="size"
           #checkbox
           type="checkbox"
           [checked]="isChecked"
           [disabled]="isDisabled"
           (click)="onClick($event)">

  </div>

  <div class="projected-content">
    <ng-content></ng-content>
  </div>
</div>

